import type { OrganizationDto } from '@/types/dtos/organizations/organization.dto.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_ORGANIZATIONS_QUERY_KEY } from '@/state/queries/organizations/use-get-organizations';

export const useCreateOrganizationMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (newOrganization: NewOrganization) => {
      const token = await getToken();
      return createOrganization(newOrganization, token ?? '');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_ORGANIZATIONS_QUERY_KEY],
      });
    },
  });
};

interface NewOrganization {
  name: string;
}

const createOrganization = async (newOrganization: NewOrganization, token: string): Promise<OrganizationDto> => {
  const url = `${import.meta.env.VITE_API_URL}/organizations`;
  return sendJSONRequest({
    url,
    method: METHOD.POST,
    body: newOrganization,
    token,
  });
};
